import { render, staticRenderFns } from "./lista.vue?vue&type=template&id=4241aebc"
import script from "./lista.vue?vue&type=script&lang=js"
export * from "./lista.vue?vue&type=script&lang=js"
import style0 from "./lista.vue?vue&type=style&index=0&id=4241aebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports